import React, { ReactNode } from 'react'
import { GoToBack } from '../GoToBack'
import { Header } from '../Header'

import { TabNavHeader, TabNavBtn } from './styles'

interface tabNavItens {
  children?: ReactNode
  selected: string;
  setSelected?: any;
  onTabSelected?: (e: React.MouseEvent, tab: string) => void,
  tabs: string[];
  backPath?: string,
}

export const TabNav: React.FC<tabNavItens> = ({ children, tabs, selected = "Dados pessoais", setSelected, onTabSelected, backPath }) => {

  const handleTabClick = (e: React.MouseEvent, tab: string) => {
    setSelected && setSelected(tab);
    onTabSelected && onTabSelected(e, tab);
  }

  return (
    <>
      <Header>      
        <TabNavBtn >
          <GoToBack />
        </TabNavBtn>

        <TabNavHeader>
          {
            tabs.map(tab => {
              const active = (tab === selected ? 'isActive ' : '');
              return (
                <li key={tab}>
                  <button className={active} onClick={(e) => handleTabClick(e, tab)}>
                    {tab}
                  </button>
                </li>
              );
            })
          }
        </TabNavHeader>
      </Header>

      {children}
    </>
  )
}